import { useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "components";
import { LaboratoryPopup } from "../../Lab/LaboratoryPopup";
import { VisitBookingPopup } from "../../Lab/VisitBookingPopup";

import "./AnalysisFixedActions.scss";

export const AnalysisFixedActions = () => {
  const { formatMessage } = useIntl();
  const [openCallPopup, setOpenCallPopup] = useState(false);
  const [openVisitPopup, setOpenVisitPopup] = useState(false);

  return (
    <>
      <div className="analysis-fixed-actions">
        <Button
          className="analysis-fixed-actions__btn analysis-fixed-actions__btn--call"
          onClick={() => setOpenCallPopup(true)}
        >
          {formatMessage({
            id: "laboratory.call-lab",
            defaultMessage: "ᲒᲐᲛᲝᲘᲫᲐᲮᲔ ᲚᲐᲑᲝᲠᲐᲢᲝᲠᲘᲐ",
          })}
        </Button>
        <Button
          className="analysis-fixed-actions__btn analysis-fixed-actions__btn--visit"
          onClick={() => setOpenVisitPopup(true)}
        >
          {formatMessage({
            id: "laboratory.book-visit",
            defaultMessage: "ᲓᲐᲯᲐᲕᲨᲜᲔ ᲕᲘᲖᲘᲢᲘ",
          })}
        </Button>
      </div>

      <LaboratoryPopup
        isOpen={openCallPopup}
        closePopup={() => setOpenCallPopup(false)}
      />

      <VisitBookingPopup
        isOpen={openVisitPopup}
        closePopup={() => setOpenVisitPopup(false)}
      />
    </>
  );
};
